module.exports = __webpack_public_path__ + "static/media/plunging.175c4554.mp4";